import { render, staticRenderFns } from "./leader_data.vue?vue&type=template&id=8533b116&scoped=true"
import script from "./leader_data.vue?vue&type=script&lang=js"
export * from "./leader_data.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8533b116",
  null
  
)

export default component.exports